import axios from "axios";
import { defaultApi } from "./axiosInstance";

export type ApplicantDocumentFileType = "passport" | "certificate" | "education" | "another";

const logUploadError = (label: string, error: unknown) => {
  if (axios.isAxiosError(error)) {
    console.log(`This is ${label} error:`, error.response?.status, error.response?.data ?? error.message);
    return;
  }
  console.log(`This is ${label} error:`, error);
};

export const documentsRequests = {
  uploadApplicantDocument: async (applicantId: number, fileType: ApplicantDocumentFileType, file: File) => {
    try {
      const formData = new FormData();
      formData.append("file", file, file.name);
      const response = await defaultApi.post(`/documents/upload_applicant_document`, formData, {
        params: { applicant_id: applicantId, file_type: fileType },
      });
      return response.data;
    } catch (error) {
      logUploadError("uploadApplicantDocument", error);
      return null;
    }
  },
  uploadUniversityDocument: async (applicantId: number, file: File) => {
    try {
      const formData = new FormData();
      formData.append("file", file, file.name);
      const response = await defaultApi.post(`/documents/upload_university_document`, formData, {
        params: { applicant_id: applicantId },
      });
      return response.data;
    } catch (error) {
      logUploadError("uploadUniversityDocument", error);
      return null;
    }
  },
};
